// extracted by mini-css-extract-plugin
module.exports = {"tag":"e2ff468f85--tag--NyUph","tag_close":"e2ff468f85--tag_close--vIsGX"};